export default __webpack_public_path__ + "static/media/corazonmedellin.bf819fdf.jpg";